export var ApplicationStatusId;
(function (ApplicationStatusId) {
    ApplicationStatusId[ApplicationStatusId["NotSet"] = 0] = "NotSet";
    ApplicationStatusId[ApplicationStatusId["Saved"] = 1] = "Saved";
    ApplicationStatusId[ApplicationStatusId["Submitted"] = 2] = "Submitted";
    ApplicationStatusId[ApplicationStatusId["Scoring"] = 3] = "Scoring";
    ApplicationStatusId[ApplicationStatusId["ManualUW"] = 4] = "ManualUW";
    ApplicationStatusId[ApplicationStatusId["AutoApproved"] = 5] = "AutoApproved";
    ApplicationStatusId[ApplicationStatusId["ManuallyApproved"] = 6] = "ManuallyApproved";
    ApplicationStatusId[ApplicationStatusId["ManuallyRejected"] = 7] = "ManuallyRejected";
    ApplicationStatusId[ApplicationStatusId["AutoRejected"] = 8] = "AutoRejected";
    ApplicationStatusId[ApplicationStatusId["Cancelled"] = 9] = "Cancelled";
    ApplicationStatusId[ApplicationStatusId["Paid"] = 10] = "Paid";
    ApplicationStatusId[ApplicationStatusId["Transferred"] = 11] = "Transferred";
    ApplicationStatusId[ApplicationStatusId["Replaced"] = 12] = "Replaced";
    ApplicationStatusId[ApplicationStatusId["Expired"] = 13] = "Expired";
    ApplicationStatusId[ApplicationStatusId["ApprovedWithConditions"] = 14] = "ApprovedWithConditions";
    ApplicationStatusId[ApplicationStatusId["Prescore"] = 17] = "Prescore";
    ApplicationStatusId[ApplicationStatusId["Processing"] = 18] = "Processing";
    ApplicationStatusId[ApplicationStatusId["Invoiced"] = 19] = "Invoiced";
    ApplicationStatusId[ApplicationStatusId["Signed"] = 20] = "Signed";
    ApplicationStatusId[ApplicationStatusId["InvestPaid"] = 21] = "InvestPaid";
    ApplicationStatusId[ApplicationStatusId["PartlyPaid"] = 22] = "PartlyPaid";
    ApplicationStatusId[ApplicationStatusId["Offer"] = 23] = "Offer";
    ApplicationStatusId[ApplicationStatusId["RejectedMissingDocumentation"] = 24] = "RejectedMissingDocumentation";
    ApplicationStatusId[ApplicationStatusId["Fulfilled"] = 25] = "Fulfilled";
    ApplicationStatusId[ApplicationStatusId["RedeemProofOfFinancing"] = 26] = "RedeemProofOfFinancing";
})(ApplicationStatusId || (ApplicationStatusId = {}));
export var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus["NotSet"] = "NotSet";
    ApplicationStatus["Saved"] = "Saved";
    ApplicationStatus["Submitted"] = "Submitted";
    ApplicationStatus["Scoring"] = "Scoring";
    ApplicationStatus["ManualUW"] = "ManualUW";
    ApplicationStatus["AutoApproved"] = "AutoApproved";
    ApplicationStatus["ManuallyApproved"] = "ManuallyApproved";
    ApplicationStatus["ManuallyRejected"] = "ManuallyRejected";
    ApplicationStatus["AutoRejected"] = "AutoRejected";
    ApplicationStatus["Cancelled"] = "Cancelled";
    ApplicationStatus["Paid"] = "Paid";
    ApplicationStatus["Transferred"] = "Transferred";
    ApplicationStatus["Replaced"] = "Replaced";
    ApplicationStatus["Expired"] = "Expired";
    ApplicationStatus["ApprovedWithConditions"] = "ApprovedWithConditions";
    ApplicationStatus["Prescore"] = "Prescore";
    ApplicationStatus["Processing"] = "Processing";
    ApplicationStatus["Invoiced"] = "Invoiced";
    ApplicationStatus["Signed"] = "Signed";
    ApplicationStatus["InvestPaid"] = "InvestPaid";
    ApplicationStatus["PartlyPaid"] = "PartlyPaid";
    ApplicationStatus["Offer"] = "Offer";
    ApplicationStatus["RejectedMissingDocumentation"] = "RejectedMissingDocumentation";
    ApplicationStatus["Fulfilled"] = "Fulfilled";
    ApplicationStatus["RedeemProofOfFinancing"] = "RedeemProofOfFinancing";
})(ApplicationStatus || (ApplicationStatus = {}));
export var DocumentStatusId;
(function (DocumentStatusId) {
    DocumentStatusId[DocumentStatusId["NotSet"] = 0] = "NotSet";
    DocumentStatusId[DocumentStatusId["MissingDocuments"] = 1] = "MissingDocuments";
    DocumentStatusId[DocumentStatusId["OriginalContractNotReceived"] = 3] = "OriginalContractNotReceived";
    DocumentStatusId[DocumentStatusId["ToAuthorization"] = 4] = "ToAuthorization";
    DocumentStatusId[DocumentStatusId["ConsiderationCaseworker"] = 9] = "ConsiderationCaseworker";
    DocumentStatusId[DocumentStatusId["ConsiderationAuthority"] = 10] = "ConsiderationAuthority";
    DocumentStatusId[DocumentStatusId["SecurityRegistration"] = 12] = "SecurityRegistration";
    DocumentStatusId[DocumentStatusId["DocumentsProduced"] = 15] = "DocumentsProduced";
    DocumentStatusId[DocumentStatusId["DocumentsOK"] = 16] = "DocumentsOK";
    DocumentStatusId[DocumentStatusId["DocumentsReceived"] = 21] = "DocumentsReceived";
    DocumentStatusId[DocumentStatusId["ToSecurityRegistration"] = 25] = "ToSecurityRegistration";
    DocumentStatusId[DocumentStatusId["SecurityRegistrationPending"] = 26] = "SecurityRegistrationPending";
    DocumentStatusId[DocumentStatusId["SecurityRegistered"] = 27] = "SecurityRegistered";
    DocumentStatusId[DocumentStatusId["Prescore"] = 31] = "Prescore";
    DocumentStatusId[DocumentStatusId["NewApplication"] = 34] = "NewApplication";
    DocumentStatusId[DocumentStatusId["Scoring"] = 35] = "Scoring";
    DocumentStatusId[DocumentStatusId["Error"] = 36] = "Error";
    DocumentStatusId[DocumentStatusId["DocumentProduction"] = 37] = "DocumentProduction";
    DocumentStatusId[DocumentStatusId["InfoArrived"] = 38] = "InfoArrived";
    DocumentStatusId[DocumentStatusId["NeedMoreInfo"] = 39] = "NeedMoreInfo";
    DocumentStatusId[DocumentStatusId["NewDocumentsReceived"] = 40] = "NewDocumentsReceived";
    DocumentStatusId[DocumentStatusId["ToPayout"] = 42] = "ToPayout";
    DocumentStatusId[DocumentStatusId["FromAuthorization"] = 44] = "FromAuthorization";
    DocumentStatusId[DocumentStatusId["DocumentControl"] = 45] = "DocumentControl";
    DocumentStatusId[DocumentStatusId["SecurityDocsReceived"] = 46] = "SecurityDocsReceived";
    DocumentStatusId[DocumentStatusId["SecurityDocsPending"] = 47] = "SecurityDocsPending";
    DocumentStatusId[DocumentStatusId["Transferred"] = 48] = "Transferred";
    DocumentStatusId[DocumentStatusId["Paid"] = 49] = "Paid";
    DocumentStatusId[DocumentStatusId["CheckDeletionOfSecurityOtherBank"] = 50] = "CheckDeletionOfSecurityOtherBank";
    DocumentStatusId[DocumentStatusId["OriginalContractReceived"] = 51] = "OriginalContractReceived";
    DocumentStatusId[DocumentStatusId["AwaitingSpecification"] = 52] = "AwaitingSpecification";
    DocumentStatusId[DocumentStatusId["DocumentsNotReturned"] = 54] = "DocumentsNotReturned";
    DocumentStatusId[DocumentStatusId["Rejected"] = 55] = "Rejected";
    DocumentStatusId[DocumentStatusId["Offer"] = 58] = "Offer";
    DocumentStatusId[DocumentStatusId["ApprovalExpired"] = 59] = "ApprovalExpired";
    DocumentStatusId[DocumentStatusId["DocumentsPartial"] = 60] = "DocumentsPartial";
    DocumentStatusId[DocumentStatusId["ObjectOrderSent"] = 62] = "ObjectOrderSent";
    DocumentStatusId[DocumentStatusId["Activated"] = 63] = "Activated";
    DocumentStatusId[DocumentStatusId["ToESign"] = 64] = "ToESign";
    DocumentStatusId[DocumentStatusId["ESigned"] = 65] = "ESigned";
    DocumentStatusId[DocumentStatusId["ESignFailed"] = 66] = "ESignFailed";
    DocumentStatusId[DocumentStatusId["CustomerAccepted"] = 67] = "CustomerAccepted";
    DocumentStatusId[DocumentStatusId["PreESigned"] = 68] = "PreESigned";
    DocumentStatusId[DocumentStatusId["NewOfferCreated"] = 69] = "NewOfferCreated";
    DocumentStatusId[DocumentStatusId["AwaitingOwnerRegistration"] = 70] = "AwaitingOwnerRegistration";
    DocumentStatusId[DocumentStatusId["OwnerRegistrationError"] = 71] = "OwnerRegistrationError";
    DocumentStatusId[DocumentStatusId["PartiallySigned"] = 72] = "PartiallySigned";
    DocumentStatusId[DocumentStatusId["FullySigned"] = 73] = "FullySigned";
    DocumentStatusId[DocumentStatusId["PaymentControl"] = 56] = "PaymentControl";
    DocumentStatusId[DocumentStatusId["ReturnFromPaymentControl"] = 74] = "ReturnFromPaymentControl";
    DocumentStatusId[DocumentStatusId["ReturnFromDocumentControl"] = 75] = "ReturnFromDocumentControl";
    DocumentStatusId[DocumentStatusId["ReturnFromUnderwriting"] = 76] = "ReturnFromUnderwriting";
    DocumentStatusId[DocumentStatusId["FullySignedIncomplete"] = 77] = "FullySignedIncomplete";
    DocumentStatusId[DocumentStatusId["SecurityRegistrationFailed"] = 78] = "SecurityRegistrationFailed";
    DocumentStatusId[DocumentStatusId["SblRequestSent"] = 79] = "SblRequestSent";
    DocumentStatusId[DocumentStatusId["WaitingForInvoice"] = 80] = "WaitingForInvoice";
    DocumentStatusId[DocumentStatusId["InvoiceReceived"] = 81] = "InvoiceReceived";
    DocumentStatusId[DocumentStatusId["ManualDocumentControl"] = 82] = "ManualDocumentControl";
    DocumentStatusId[DocumentStatusId["CarOrderConfirmationReceived"] = 83] = "CarOrderConfirmationReceived";
    DocumentStatusId[DocumentStatusId["CarOrderReceived"] = 84] = "CarOrderReceived";
    DocumentStatusId[DocumentStatusId["ProofOfDeliverySent"] = 85] = "ProofOfDeliverySent";
    DocumentStatusId[DocumentStatusId["ProofOfDeliveryAccepted"] = 86] = "ProofOfDeliveryAccepted";
    DocumentStatusId[DocumentStatusId["PreTransferSecurityRegisrationFailed"] = 87] = "PreTransferSecurityRegisrationFailed";
    DocumentStatusId[DocumentStatusId["CustomerRejectedInformationAccess"] = 88] = "CustomerRejectedInformationAccess";
})(DocumentStatusId || (DocumentStatusId = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["NotSet"] = "NotSet";
    DocumentStatus["MissingDocuments"] = "MissingDocuments";
    DocumentStatus["OriginalContractNotReceived"] = "OriginalContractNotReceived";
    DocumentStatus["ToAuthorization"] = "ToAuthorization";
    DocumentStatus["ConsiderationCaseworker"] = "ConsiderationCaseworker";
    DocumentStatus["ConsiderationAuthority"] = "ConsiderationAuthority";
    DocumentStatus["SecurityRegistration"] = "SecurityRegistration";
    DocumentStatus["DocumentsProduced"] = "DocumentsProduced";
    DocumentStatus["DocumentsOK"] = "DocumentsOK";
    DocumentStatus["DocumentsReceived"] = "DocumentsReceived";
    DocumentStatus["ToSecurityRegistration"] = "ToSecurityRegistration";
    DocumentStatus["SecurityRegistrationPending"] = "SecurityRegistrationPending";
    DocumentStatus["SecurityRegistered"] = "SecurityRegistered";
    DocumentStatus["Prescore"] = "Prescore";
    DocumentStatus["NewApplication"] = "NewApplication";
    DocumentStatus["Scoring"] = "Scoring";
    DocumentStatus["Error"] = "Error";
    DocumentStatus["DocumentProduction"] = "DocumentProduction";
    DocumentStatus["InfoArrived"] = "InfoArrived";
    DocumentStatus["NeedMoreInfo"] = "NeedMoreInfo";
    DocumentStatus["NewDocumentsReceived"] = "NewDocumentsReceived";
    DocumentStatus["ToPayout"] = "ToPayout";
    DocumentStatus["FromAuthorization"] = "FromAuthorization";
    DocumentStatus["DocumentControl"] = "DocumentControl";
    DocumentStatus["SecurityDocsReceived"] = "SecurityDocsReceived";
    DocumentStatus["SecurityDocsPending"] = "SecurityDocsPending";
    DocumentStatus["Transferred"] = "Transferred";
    DocumentStatus["Paid"] = "Paid";
    DocumentStatus["CheckDeletionOfSecurityOtherBank"] = "CheckDeletionOfSecurityOtherBank";
    DocumentStatus["OriginalContractReceived"] = "OriginalContractReceived";
    DocumentStatus["AwaitingSpecification"] = "AwaitingSpecification";
    DocumentStatus["DocumentsNotReturned"] = "DocumentsNotReturned";
    DocumentStatus["Rejected"] = "Rejected";
    DocumentStatus["Offer"] = "Offer";
    DocumentStatus["ApprovalExpired"] = "ApprovalExpired";
    DocumentStatus["DocumentsPartial"] = "DocumentsPartial";
    DocumentStatus["ObjectOrderSent"] = "ObjectOrderSent";
    DocumentStatus["Activated"] = "Activated";
    DocumentStatus["ToESign"] = "ToESign";
    DocumentStatus["ESigned"] = "ESigned";
    DocumentStatus["ESignFailed"] = "ESignFailed";
    DocumentStatus["CustomerAccepted"] = "CustomerAccepted";
    DocumentStatus["PreESigned"] = "PreESigned";
    DocumentStatus["NewOfferCreated"] = "NewOfferCreated";
    DocumentStatus["AwaitingOwnerRegistration"] = "AwaitingOwnerRegistration";
    DocumentStatus["OwnerRegistrationError"] = "OwnerRegistrationError";
    DocumentStatus["PartiallySigned"] = "PartiallySigned";
    DocumentStatus["FullySigned"] = "FullySigned";
    DocumentStatus["PaymentControl"] = "PaymentControl";
    DocumentStatus["ReturnFromPaymentControl"] = "ReturnFromPaymentControl";
    DocumentStatus["ReturnFromDocumentControl"] = "ReturnFromDocumentControl";
    DocumentStatus["ReturnFromUnderwriting"] = "ReturnFromUnderwriting";
    DocumentStatus["FullySignedIncomplete"] = "FullySignedIncomplete";
    DocumentStatus["SecurityRegistrationFailed"] = "SecurityRegistrationFailed";
    DocumentStatus["SblRequestSent"] = "SblRequestSent";
    DocumentStatus["SblRequestReceived"] = "SblRequestReceived";
    DocumentStatus["WaitingForInvoice"] = "WaitingForInvoice";
    DocumentStatus["InvoiceReceived"] = "InvoiceReceived";
    DocumentStatus["ManualDocumentControl"] = "ManualDocumentControl";
    DocumentStatus["CarOrderConfirmationReceived"] = "CarOrderConfirmationReceived";
    DocumentStatus["CarOrderReceived"] = "CarOrderReceived";
    DocumentStatus["ProofOfDeliverySent"] = "ProofOfDeliverySent";
    DocumentStatus["ProofOfDeliveryAccepted"] = "ProofOfDeliveryAccepted";
    DocumentStatus["PreTransferSecurityRegisrationFailed"] = "PreTransferSecurityRegisrationFailed";
    DocumentStatus["CustomerRejectedInformationAccess"] = "CustomerRejectedInformationAccess";
})(DocumentStatus || (DocumentStatus = {}));
//# sourceMappingURL=ApplicationStatus.js.map